import { App, KernelRouteEndpoint, KernelRoute } from "../../../kernel/kernel";
import Radio from "backbone.radio";
import raf from "raf";

/**
 * Settings route
 *
 * @extends KernelRoute
 */
class SettingsRoute extends KernelRoute {

    /**
     * When the user hits the index page, show the index page
     */
    @KernelRouteEndpoint("/settings(/)")
    route () {
        const that = this;
        this.radio = Radio.channel("app:router");

        System.import("./index").then(View => {
            const view = new View.default();
            raf(_ => App.contentRegion.show(view));
        });
    }
}

export default SettingsRoute;



// WEBPACK FOOTER //
// ./public/domain/views/settings/settings.route.js